import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import * as Models from '../models/';

export const StatementStatusComponent: React.FC<any> = observer(
	() =>
	{
		const { dataState } = useStores();

		function ShowStatus(order: number, statusCode: Models.StatementStatusEnum)
		{
			let name = dataState.StatusCodes.get(statusCode)?.Name;
			let dt = dataState.StatusHistory.get(statusCode);

			return (
				<div className={"statement-step d-flex" + (dt ? " passed" : "")}>
					<div className="statement-step-icon mr-2">{order}</div>
					<div className="statement-step-text">
						<p className="mb-0">{name}</p>
						<div className="statement-passed-date">{dt ? Models.ISODateTimeOffset.ConvertToStatusTime(dt) : ""}</div>
					</div>
				</div>
			);
		}

		return (
			<div className="statement-steps-progress">
				{ShowStatus(1, Models.StatementStatusEnum.Created)}
				{ShowStatus(2, Models.StatementStatusEnum.Signed)}
				{ShowStatus(3, Models.StatementStatusEnum.Sent)}
				{ShowStatus(4, Models.StatementStatusEnum.Received)}
			</div>
		);
	}
)
